import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import {
  canAccessFinance,
  canManageInternalUsers,
  isOperations,
} from "../../helpers/adminRoles";

class SideBar extends Component {
  closeNav = () => {
    if (document.getElementById("mySidenav")) {
      document.getElementById("mySidenav").style.width = "0";
    }
  };

  //  Every panel role gets this one menu. What an operations user may do with
  //  it is decided per screen (see adminRoles.js): Order Medicine in full,
  //  everything else read-only, Finance not at all - which is why the Finance
  //  tab below greys itself out instead of disappearing.
  render() {
    const financeOpen = canAccessFinance();
    //  Operations only owns Order Medicine (Pharmacies included) - everything
    //  else in the panel is someone else's area, so it is hidden from their
    //  sidebar entirely rather than shown read-only.
    const opsOnly = isOperations();
    return (
      <div id="mySidenav" className="sidenav">
        <a href="#" className="closebtn" onClick={this.closeNav}>
          &times;
        </a>
        <div id="accordion">
          <div className="side_box">
            {!opsOnly && (
              <React.Fragment>
                <Link className="side_txt" to="/admin" onClick={this.closeNav}>
                  Dashboard
                </Link>

                {/* <Link className="side_txt" to="/admin/layout" onClick={this.closeNav}>
              Layout
            </Link> */}

                <div
                  className="dropdown-container show"
                  id="collapseOne"
                  class="collapse"
                  data-parent="#accordion"
                >
                  <Link
                    className="side_txt active"
                    to="/admin/Viewmastermodules"
                    onClick={this.closeNav}
                  >
                    Sub Modules
                  </Link>
                </div>

                <a
                  className="dropdown-btn side_txt"
                  onClick={this.showmenu}
                  data-toggle="collapse"
                  href="#collapseTwo"
                >
                  Configurations
                  <i className="fa fa-caret-down"></i>
                </a>
                <div
                  className="dropdown-container"
                  id="collapseTwo"
                  class="collapse"
                  data-parent="#accordion"
                >
                  <Link
                    className="side_txt active"
                    to="/admin/Viewcategory"
                    onClick={this.closeNav}
                  >
                    Category
                  </Link>
                  <Link
                    className="side_txt active"
                    to="/admin/Viewlanguages"
                    onClick={this.closeNav}
                  >
                    Languages
                  </Link>
                  <Link
                    className="side_txt active"
                    to="/admin/Createviewrelationships"
                    onClick={this.closeNav}
                  >
                    Relationships
                  </Link>
                  <Link
                    className="side_txt active"
                    to="/admin/Viewspecializations"
                    onClick={this.closeNav}
                  >
                    Specializations
                  </Link>
                  <Link
                    className="side_txt active"
                    to="/admin/Viewcancellationreasons"
                    onClick={this.closeNav}
                  >
                    Order Cancellation Reasons
                  </Link>
                </div>
                <a
                  className="dropdown-btn side_txt"
                  data-toggle="collapse"
                  href="#collapseThree"
                >
                  Clinic Setup <i className="fa fa-caret-down"></i>
                </a>
                <div
                  className="dropdown-container"
                  id="collapseThree"
                  class="collapse"
                  data-parent="#accordion"
                >
                  {/* <Link
                className="side_txt active"
                to="/admin/Viewmastersubclinicpagemodules"
                onClick={this.closeNav}
              >
                Clinic Page Modules
              </Link> */}
                  <Link
                    className="side_txt active"
                    to="/admin/ViewClinics"
                    onClick={this.closeNav}
                  >
                    View Clinics
                  </Link>
                  {/* <Link
                className="side_txt active"
                to="/admin/ViewDoctorAdmin"
                onClick={this.closeNav}
              >
                View Doctor Admin
              </Link> */}
                  <Link
                    className="side_txt active"
                    to="/admin/ViewDoctors"
                    onClick={this.closeNav}
                  >
                    View Doctors
                  </Link>

                  <Link
                    className="side_txt active"
                    to="/admin/ViewDoctorSlots"
                    onClick={this.closeNav}
                  >
                    View Slots
                  </Link>

                  <Link
                    className="side_txt active"
                    to="/admin/Viewcoupons"
                    onClick={this.closeNav}
                  >
                    View Coupons
                  </Link>
                  <Link
                    className="side_txt active"
                    to="/admin/Viewbanners"
                    onClick={this.closeNav}
                  >
                    View Banners
                  </Link>

                  <Link
                    className="side_txt active"
                    to="/admin/ViewOffers"
                    onClick={this.closeNav}
                  >
                    View Offers
                  </Link>
                  <Link
                    className="side_txt active"
                    to="/admin/Viewsubscriptions"
                    onClick={this.closeNav}
                  >
                    View Subscriptions
                  </Link>
                  <Link
                    className="side_txt active"
                    to="/admin/ViewSubscriptionUsers"
                    onClick={this.closeNav}
                  >
                    View Users Subscription
                  </Link>
                </div>

                <a
                  className="dropdown-btn side_txt"
                  data-toggle="collapse"
                  href="#collapseDiagnosis"
                >
                  Diagnostics <i className="fa fa-caret-down"></i>
                </a>
                <div
                  className="dropdown-container"
                  id="collapseDiagnosis"
                  class="collapse"
                  data-parent="#accordion"
                >
                  <Link
                    className="side_txt active"
                    to="/admin/DiagnosisViewOrders"
                    onClick={this.closeNav}
                  >
                    View Orders
                  </Link>
                  <Link
                    className="side_txt active"
                    to="/admin/ViewDiagnostics"
                    onClick={this.closeNav}
                  >
                    View Diagnostics
                  </Link>
                  <Link
                    className="side_txt active"
                    to="/admin/ViewProductrequest"
                    onClick={this.closeNav}
                  >
                    {/* <i className="fa fa-dashboard"></i> */}
                    Product Request
                  </Link>
                  {/* <Link
                className="side_txt active"
                to="/admin/Vieworders"
                onClick={this.closeNav}
              >
                 <i className="fa fa-dashboard"></i>
                Lab Reports
              </Link> */}
                </div>
              </React.Fragment>
            )}

            <a
              className={"dropdown-btn side_txt" + (opsOnly ? " active" : "")}
              data-toggle="collapse"
              href="#collapseFive"
            >
              {/* <i className="fa fa-user-plus"></i> */}
              Order Medicine
              <i className="fa fa-caret-down"></i>
            </a>
            <div
              className={"collapse" + (opsOnly ? " show" : "")}
              id="collapseFive"
              data-parent="#accordion"
            >
              <Link
                className="side_txt active"
                to="/admin/Vieworders"
                onClick={this.closeNav}
              >
                {/* <i className="fa fa-dashboard"></i> */}
                Orders
              </Link>
              <Link
                className="side_txt active"
                to="/admin/ViewProductrequestOM"
                onClick={this.closeNav}
              >
                {/* <i className="fa fa-dashboard"></i> */}
                Product Request
              </Link>
              <Link
                className="side_txt active"
                to="/admin/ViewProducts"
                onClick={this.closeNav}
              >
                {/* <i className="fa fa-dashboard"></i> */}
                View Products
              </Link>
              <Link
                className="side_txt active"
                to="/admin/UploadMasterProducts"
                onClick={this.closeNav}
              >
                {/* <i className="fa fa-upload"></i> */}
                Upload Master Products
              </Link>
              <Link
                className="side_txt active"
                to="/admin/product-approvals"
                onClick={this.closeNav}
              >
                {/* <i className="fa fa-check-circle"></i> */}
                Product Approvals
              </Link>
              <Link
                className="side_txt active"
                to="/admin/StockUpload"
                onClick={this.closeNav}
              >
                Stock Upload
              </Link>
              <Link
                className="side_txt active"
                to="/admin/ViewRetailers"
                onClick={this.closeNav}
              >
                {/* <i className="fa fa-dashboard"></i> */}
                Pharmacies
              </Link>
              <Link
                className="side_txt active"
                to="/admin/ViewRetailersWalletList"
                onClick={this.closeNav}
              >
                {/* <i className="fa fa-dashboard"></i> */}
                Pharmacy Wallet List
              </Link>

              {/* <Link
                className="side_txt active"
                to="/admin/Viewrevenue"
                onClick={this.closeNav}
              >
                <i className="fa fa-dashboard"></i>
                Revenue & Commissions
              </Link> */}

              {/* <Link
              className="side_txt active"
              to="/admin/ViewProducts"
              onClick={this.closeNav}
            >
              <i className="fa fa-dashboard"></i>View Products
            </Link> */}
            </div>

            {!opsOnly && (
              <React.Fragment>
                <a
                  className="dropdown-btn side_txt"
                  data-toggle="collapse"
                  href="#collapseSix"
                >
                  Reports
                  <i className="fa fa-caret-down"></i>
                </a>
                <div
                  className="dropdown-container"
                  id="collapseSix"
                  class="collapse"
                  data-parent="#accordion"
                >
                  <Link
                    className="side_txt active"
                    to="/admin/viewConsultations"
                    onClick={this.closeNav}
                  >
                    Consultations
                  </Link>

                  <Link
                    className="side_txt active"
                    to="/admin/Coupons"
                    onClick={this.closeNav}
                  >
                    Coupons
                  </Link>

                  <Link
                    className="side_txt active"
                    to="/admin/ClinicPatients"
                    onClick={this.closeNav}
                  >
                    Clinic Patients
                  </Link>
                  <Link
                    className="side_txt active"
                    to="/admin/SearchAppointments"
                    onClick={this.closeNav}
                  >
                    Search Appointments
                  </Link>
                </div>
              </React.Fragment>
            )}

            {!opsOnly && (financeOpen ? (
              <React.Fragment>
                <a
                  className="dropdown-btn side_txt"
                  onClick={this.showmenu}
                  data-toggle="collapse"
                  href="#collapseSeven"
                >
                  Finance
                  <i className="fa fa-caret-down"></i>
                </a>
                <div
                  className="dropdown-container"
                  id="collapseSeven"
                  class="collapse"
                  data-parent="#accordion"
                >
                  <Link
                    className="side_txt active"
                    to="/admin/ViewFinanceUsers"
                    onClick={this.closeNav}
                  >
                    View Users
                  </Link>
                </div>
              </React.Fragment>
            ) : (
              <span
                className="side_txt ops-locked"
                title="Finance is not available for your role"
              >
                Finance
                <i className="fa fa-lock"></i>
              </span>
            ))}

            {/* Handing out panel access is the Super Admin's alone */}
            {canManageInternalUsers() && (
              <React.Fragment>
                <a
                  className="dropdown-btn side_txt"
                  data-toggle="collapse"
                  href="#collapseEight"
                >
                  Operations
                  <i className="fa fa-caret-down"></i>
                </a>
                <div
                  className="dropdown-container"
                  id="collapseEight"
                  class="collapse"
                  data-parent="#accordion"
                >
                  <Link
                    className="side_txt active"
                    to="/admin/ViewOperationsUsers"
                    onClick={this.closeNav}
                  >
                    View Users
                  </Link>
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    );
  }
  F;
}

export default withRouter(SideBar);
